/**
 * Reads a boolean feature flag from an environment object. Fail-closed: environment files are gitignored, so a
 * deployer's file without the key means the feature is off, not a build error.
 */
export function envFlag(env: object, key: string): boolean {
  return (env as Record<string, unknown>)[key] === true;
}
